<template>
  <modal :id="id" :modifiers="['no-horizontal-padding']">
    <div class="status-modal">
      <sprite :id="statusSprite" class="status-modal__icon" />
      <h3 class="status-modal__headline">
        {{ headline }}
      </h3>
      <div class="status-modal__text">
        {{ message }}
      </div>
      <div class="status-modal__footer">
        <button class="status-modal__submit button" @click="close">
          {{ $t(buttonType) }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Sprite from "@/shared/sprite"
import Modal from "@/shared/modal"
import events from "@/bl-events/index"
import "/wds/sprites/app/added.svg"
import "/wds/sprites/app/error.svg"

/** @emits closed */
export default {
  name: "StatusModal",
  components: { Modal, Sprite },
  props: {
    id: { type: String, default: null },
    status: { type: String, default: "success" }, // "success" || "error"
    headline: { type: String, default: "" },
    message: { type: String, default: "" },
    buttonType: { type: String, default: "close" }
  },
  computed: {
    statusSprite() {
      if (this.status === "success") {
        return "app/added"
      } else {
        return "app/error"
      }
    }
  },
  mounted() {
    events.on(`modal:${this.id}:closed`, () => {
      this.$emit("closed")
    })
  },
  methods: {
    close() {
      events.emit(`modal:${this.id}:close`)
    }
  },
  i18n: {
    messages: {
      en: {
        close: "Close",
        continue: "Continue"
      },
      de: {
        close: "Schließen",
        continue: "Fortfahren"
      },
      es: {
        close: "Cerrar",
        continue: "Continuar"
      },
      pt: {
        close: "Fechar",
        continue: "Continuar"
      }
    }
  }
}
</script>

<style lang="scss">
.status-modal {
  width: 100vw;
  max-width: $x-wide-block-width;
  padding: $spacing-48 $spacing-24 $spacing-24;

  &__icon {
    display: block;
    width: $spacing-48;
    height: $spacing-48;
    margin: 0 auto $spacing-24;

    color: $green;

    &.sprite-vue--error {
      color: $red;
    }
  }

  &__headline {
    @include font-style(h3);

    margin-bottom: $spacing-24;
  }

  &__text {
    @include font-style(p);

    margin-bottom: $spacing-24;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  &__submit {
    min-width: spacing(118px);
  }
}
</style>
